import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import PublicHeader from '../components/PublicHeader';
import PublicFooter from '../components/PublicFooter';
import DocumentTitle from '../components/DocumentTitle';
import MetaDescription from '../components/MetaDescription';

const ApplicationSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const jobTitle = searchParams.get('jobTitle');

  return (
    <div className="min-h-screen bg-white">
      <DocumentTitle title="Application Submitted" suffix="Success" />
      <MetaDescription description="Your job application has been submitted successfully. Thank you for your interest in joining our team." />
      <PublicHeader />

      {/* Main Content */}
      <main>
        <div className="max-w-2xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
              <CheckCircleIcon className="h-8 w-8 text-green-600" />
            </div>
            
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Application Submitted Successfully!
            </h1>
            
            <p className="text-lg text-gray-600 mb-8">
              Thank you for your interest in joining our team. Your application has been received and will be reviewed by our hiring team.
            </p>

            {jobTitle && (
              <div className="bg-gray-50 rounded-lg p-6 mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  Position Applied For
                </h2>
                <p className="text-gray-700">{jobTitle}</p>
              </div>
            )}

            <div className="bg-blue-50 rounded-lg p-6 mb-8">
              <h3 className="text-lg font-semibold text-blue-900 mb-3">
                What happens next?
              </h3>
              <ul className="text-left text-blue-800 space-y-2">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>We'll review your application within 1-2 business days</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>If your profile matches our requirements, we'll contact you for next steps</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>You'll receive an email confirmation of your application</span>
                </li>
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/jobs"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
              >
                View Other Positions
              </Link>
              <Link
                to="/"
                className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default ApplicationSuccessPage;
